import {
  transformApplicantToApi
} from '@applyonline/shared'

import { Prequalification } from '../types/Schemas/PrequalificationSchema'

export function transformPrequalToApi(prequal: Prequalification): Prequalification {
  return {
    ...prequal,
    applicant: transformApplicantToApi(prequal.applicant),
  } as Prequalification
}